import script from "./VehicleAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleAvatar.vue?vue&type=script&setup=true&lang=js"

import "./VehicleAvatar.vue?vue&type=style&index=0&id=4a03ebde&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a03ebde"]])

export default __exports__